import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card p-3 d-flex flex-row align-items-center shadow-sm" }
const _hoisted_2 = { class: "ms-3" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "fw-bold fs-5" }

import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    default: "",
  },
  useSvg: Boolean,
  color: String,
  icon: String,
},
  setup(__props) {

const props = __props


const bgClass = computed(() => `bg-${props.color}`);
const textClass = computed(() => `text-${props.color}`);

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([['bg-opacity-25', _unref(bgClass)], "rounded-circle d-flex align-items-center justify-content-center"]),
      style: {"width":"48px","height":"48px"}
    }, [
      (props.useSvg)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(_unref(textClass)),
            id: "infoIcon"
          }, [
            _createVNode(_component_inline_svg, { src: "/media/icons/superadmin/client.svg" })
          ], 2))
        : (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: _normalizeClass([__props.icon, _unref(textClass), 'fs-4'])
          }, null, 2))
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("small", _hoisted_3, _toDisplayString(props.title), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(props.text), 1)
    ])
  ]))
}
}

})